<template>
  <div>
    <h2>Mail'e do wysłania</h2>
    <v-row>
      <v-col>Wszystkie maile zostaną wysłane osobno</v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn color="primary" class="mr-2" @click="addMailsFromCompanies"
          >Dodaj maile z wdrożeń do pola "Do"</v-btn
        >
        <v-btn color="warning" @click="clearAll">Wyczyść wszystkie pola</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="6">
        <v-text-field label="Do kogo" v-model="toAsString"></v-text-field>
      </v-col>
      <v-col cols="12" lg="6">
        <v-text-field label="Pole od" v-model="from"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field label="Tytuł" v-model="title"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ckeditor
          v-model="content"
          :config="editorConfig"
          editorUrl="https://cdn.ckeditor.com/4.14.0/full-all/ckeditor.js"
        ></ckeditor>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn color="primary" @click="addToSend">Wyślij</v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="progressDialog" width="800" persistent scrollable>
      <v-card>
        <v-card-title>Dodawanie maili do kolejki</v-card-title>
        <v-card-text>
          <v-progress-linear
            :color="mailAdded == toAsArray.length ? 'success' : 'primary'"
            height="25"
            rounded
            :value="progressLinear"
            >{{ mailAdded }}/{{ toAsArray.length }}</v-progress-linear
          >
          <v-row v-if="addedResult">
            <v-col>
              <div v-if="addedResult == 'success'">
                Dodano wszystkie maile do wysyłki
                <br />
                <v-btn color="primary" to="/Mails"
                  >Przejrz do skrzynki maili</v-btn
                >
              </div>
              <div v-if="addedResult == 'partialSuccess'">
                Nie udało się dodać niektórych maili do wysyłki
                <v-btn color="primary" to="/Mails"
                  >Przejrz do skrzynki maili</v-btn
                >
                <v-switch v-model="showErrorMails"
                  >Pokaż maile których nie udało się wysłać</v-switch
                >
              </div>
              <div v-if="addedResult == 'failed'">
                Nie udało się dodać żadnego maila do wysyłki
              </div>
              <br />
              <v-btn color="primary" @click="progressDialog = false"
                >Ukryj okno</v-btn
              >
            </v-col>
          </v-row>
          <v-row v-if="true">
            <v-col>
              {{ failedMails.join("; ") }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import CKEditor from "ckeditor4-vue";
export default {
  data: () => ({
    editorConfig: {
      height: 500,
    },
    toAsString: "",
    from: "",
    title: "",
    content: "",
    progressDialog: false,
    mailAdded: 0,
    addedResult: null,
    failedMails: [],
    showErrorMails: false,
  }),
  computed: {
    toAsArray() {
      var vm = this;
      if (!vm.toAsString) {
        return [];
      }
      return vm.toAsString
        .split(",")
        .map((el) => el.trim())
        .filter((el) => !!el);
    },
    progressLinear() {
      var vm = this;
      if (vm.toAsArray.length > 0) {
        return ((vm.mailAdded / vm.toAsArray.length) * 100.0).toFixed(2);
      } else {
        return 0;
      }
    },
  },
  components: {
    ckeditor: CKEditor.component,
  },
  methods: {
    clearAll() {
      var vm = this;
      (vm.title = ""), (vm.toAsString = ""), (vm.from = ""), (vm.content = "");
    },
    addMailsFromCompanies() {
      var vm = this;
      vm.$http.get("Mail/GetEmailsFromCompanies").then((response) => {
        if (vm.toAsString && !vm.toAsString.endsWith(",")) {
          vm.toAsString += ",";
        }
        response.data.forEach((mail) => {
          vm.toAsString += mail + ",";
        });
      });
    },
    addToSend() {
      var vm = this;
      vm.addedResult = null;
      vm.failedMails = [];
      vm.mailAdded = 0;
      (vm.showErrorMails = false), (vm.progressDialog = true);
      var mails = vm.toAsArray.map((mailTo) => {
        return {
          address: mailTo,
          title: vm.title,
          from: vm.from,
          body: vm.content,
        };
      });
      vm.$http
        .post("Mail/AddEmailToQueueRange", mails)
        .then((response) => {
          vm.addedResult = "success";
          vm.mailAdded = mails.length
        })
        .catch((error) => {
          vm.addedResult = "failed";
        });
    },
  },
};
</script>>